const enums = {
  PUBLISHED: { text: '已发布', value: 2 },
  UNPUBLISHED: { text: '未发布', value: 1 }
}
export default enums
